import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CollectionComponent } from './collection.component';
import { ProductAddonsComponent } from './product-addons/product-addons.component';
import { ProductDetailsComponent } from './product-details/product-details.component';

const routes: Routes = [
	{
		path: '',
		component: CollectionComponent
	},
	{
		path: 'product/:code',
		component: ProductDetailsComponent
	},
	{
		path: 'productaddons/:code',
		component: ProductAddonsComponent
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class CollectionRoutingModule { }
